<script>
export default {
  props: {
    secondaryItem: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // O `isActive` do slot de <router-link> casa por PREFIXO: estando em
    // /contacts/wallet, o link de /contacts tambem se considera ativo, e "Todos os Contatos"
    // acendia junto com "Carteira de Contatos".
    //
    // Quando a config do item declara sua propria regra (contacts.js e companies.js declaram,
    // comparando route.name), ela e a autoridade e o prefixo do router e ignorado. As demais
    // secoes da sidebar nao declaram regra e continuam dependendo do prefixo — que la e o
    // comportamento desejado, porque sub-rotas como /settings/inboxes/:id devem manter o item
    // pai aceso.
    hasExplicitActiveRule() {
      return typeof this.secondaryItem.isActive === 'function';
    },
  },
  methods: {
    resolveActive(isRouteActive) {
      if (this.hasExplicitActiveRule) return this.isActive;

      return this.isActive || isRouteActive;
    },
  },
};
</script>

<template>
  <router-link
    v-slot="{ href, isActive: isRouteActive, navigate }"
    :to="secondaryItem.toState"
    custom
  >
    <a
      :href="href"
      class="flex items-center gap-3 px-4 py-3 rounded-lg text-primary-100 hover:bg-primary-900/40 transition-colors"
      :class="{ 'bg-primary-900/40 text-white': resolveActive(isRouteActive) }"
      @click="navigate"
    >
      <fluent-icon
        :icon="secondaryItem.icon"
        :class="{ 'text-white': resolveActive(isRouteActive) }"
      />
      <span class="font-medium">{{
        $t(`SIDEBAR.${secondaryItem.label}`)
      }}</span>
      <span
        v-if="secondaryItem.badge === 'BETA'"
        class="ml-2 inline-flex items-center px-1 py-1 rounded-md text-xxs font-bold uppercase tracking-wider bg-amber-500 text-white leading-none"
      >
        {{ secondaryItem.badge }}
      </span>
    </a>
  </router-link>
</template>
